module.exports = __webpack_public_path__ + "img/KitkitShuleTools.7b6c6aec.png";